import React from 'react'
import { Cell } from 'rsuite-table'
import { Whisper, Tooltip } from 'rsuite'
import EmailIcon from '@rsuite/icons/Email'
import './EmailIconCell.scss'

type RowData = {
  [key: string]: string | boolean | undefined
}

type EmailIconCellProps = {
  rowData?: RowData
  dataKey: string
}

const EmailIconCell: React.FC<EmailIconCellProps> = ({
  rowData,
  dataKey,
  ...props
}) => {
  const emailId = rowData?.[dataKey] as string | undefined

  if (!emailId) {
    return <Cell {...props}>-</Cell>
  }

  return (
    <Cell {...props} className="email-icon-cell">
      <Whisper
        placement="top"
        controlId="control-id-hover"
        trigger="hover"
        speaker={<Tooltip>{emailId}</Tooltip>}
      >
        <div className="email-icon-wrapper">
          <EmailIcon className="email-icon" />
        </div>
      </Whisper>
    </Cell>
  )
}

export default EmailIconCell
